import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { CarouselWrap } from './styles.js';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 1024, min: 500 },
    items: 3,
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 2,
    partialVisibilityGutter: 30,
  },
};

const ImageScroller = {
  all: {
    breakpoint: { max: 4000, min: 0 },
    items: 1,
  },
};

export const HorizontalScroll = (props) => {
  const { children, useImageScroller } = props;

  return (
    <CarouselWrap>
      <Carousel responsive={useImageScroller ? ImageScroller : responsive} autoPlay={false} shouldResetAutoplay={false} slidesToSlide={3} {...props}>
        {children}
      </Carousel>
    </CarouselWrap>
  );
};
